// START IMPORTS
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { Stack, Text, styled, useTheme } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { ObituarySearchForm } from '@ltvco/refresh-lib/v1';
import { Favorite } from '@mui/icons-material';
import { Fragment, useContext, useEffect } from 'react';
// END IMPORTS

// START STYLED_COMPONENTS
const TextWithIcon = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 0,

  svg: {
    marginRight: theme.spacing(1),
  },
}));
// END STYLED_COMPONENTS

export function ObituarySearchPage() {
  // START HOOKS_AND_QUERIES
  const { isMobile } = useScreenSize();
  const theme = useTheme();
  const { trackEvent, trackEventGA4 } = useContext(AppConfig);
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  trackEvent('view obituary search page', 'view', 'obituary search view');

  function trackGA4() {
    trackEventGA4({
      event_name: 'report_search',
      report_type: 'obituary',
      search_by: 'obituary',
      search_from: 'obituary_search_page',
    });
  }
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    document.title = 'Obituary Search - PeopleLooker';
  }, []);
  // END EFFECTS

  // START RENDER
  return (
    <Fragment>
      <Stack gap={2}>
        <TextWithIcon variant="h1">
          <Favorite
            sx={{ color: theme.palette.primary.main }}
            fontSize="large"
          />{' '}
          Obituary Search
        </TextWithIcon>
        <ObituarySearchForm miniView={isMobile} trackEvent={trackGA4} />
      </Stack>
    </Fragment>
  );
  // END RENDER
}
